import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js';
import {
  HomeOutlined,
  ShopOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  BarChartOutlined,
  NotificationOutlined,
  LogoutOutlined,
  TeamOutlined,
  LeftOutlined,
  RightOutlined,
  IdcardOutlined,
  FilePdfOutlined
} from '@ant-design/icons';
import { isResumenCuentaEnabledForCoop } from '../../utils/resumenCuentaAccess.js';
import { isResumenCuentaImpresionEnabledForCoop } from '../../utils/resumenCuentaImpresionAccess.js';
import { isNoticiaEnabledForCoop } from '../../utils/noticiaAccess.js';

const { Content, Sider } = Layout;

const MainLayout = ({ children }) => {
  const { user, logout } = useContext(LoginContext);
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const permisos = user?.user?.permisosDashboard || {};
  const canManageUsers =
    !!user?.user?.idCooperativa &&
    (user?.user?.tipoUsuario === 'administrador' || user?.user?.puedeGestionarUsuarios === true);

  useEffect(() => {
    if (!user) {
      navigate('/login'); // Redirige al login si no hay usuario
    }
  }, [user, navigate]);

  // Menú para administradores globales
  const adminMenuItems = [
    { key: '1', icon: <HomeOutlined />, label: <Link to="/">Inicio</Link> },
    { key: '2', icon: <TeamOutlined />, label: <Link to="/usuarios">Usuarios</Link> },
    {
      key: '10',
      icon: <LogoutOutlined style={{ color: 'red' }} />,
      label: (
        <span style={{ color: 'red' }} onClick={() => logout()}>
          Cerrar sesión
        </span>
      ),
    }
  ];

  // Menú para clientes
  const enableResumenCuenta = isResumenCuentaEnabledForCoop(user?.user?.idCooperativa);
  const enableResumenCuentaImpresion = isResumenCuentaImpresionEnabledForCoop(
    user?.user?.idCooperativa
  );
  const enableNoticia = isNoticiaEnabledForCoop(user?.user?.idCooperativa);

  const clientMenuItems = [
    { key: '1', icon: <HomeOutlined />, label: <Link to="/home-cliente">Inicio</Link> },
    { key: '2', icon: <IdcardOutlined />, label: <Link to="/cuentas">Cuentas</Link> },
    ...(permisos.cereales !== false
      ? [{ key: '3', icon: <AppstoreOutlined />, label: <Link to="/cereales">Cereales</Link> }]
      : []),
    ...(permisos.supermercado !== false
      ? [{ key: '4', icon: <ShoppingCartOutlined />, label: <Link to="/supermercado">Supermercado</Link> }]
      : []),
    ...(permisos.hacienda !== false
      ? [{ key: '5', icon: <ShopOutlined />, label: <Link to="/hacienda">Hacienda</Link> }]
      : []),
    ...(permisos.auditoria !== false
      ? [{ key: '6', icon: <BarChartOutlined />, label: <Link to="/auditoria">Estadísticas</Link> }]
      : []),
    ...(enableResumenCuentaImpresion
      ? [{
          key: '8',
          icon: <FilePdfOutlined />,
          label: <Link to="/imprimir-resumen-cuenta">Resumen de cuenta</Link>,
        }]
      : []),
    {
      key: '7',
      icon: <NotificationOutlined />,
      label: 'Difundir',
      children: [
        //{ key: '7-3', label: <Link to="/difundir">Mensaje</Link> },
        ...(permisos.difundirRomaneos !== false
          ? [{ key: '7-1', label: <Link to="/difundir-romaneos">Romaneos</Link> }]
          : []),
        ...(permisos.difundirCereales !== false
          ? [{ key: '7-2', label: <Link to="/difundir-cereales">Cereales</Link> }]
          : []),
        ...(enableResumenCuenta && permisos.difundirResumenCuenta !== false
          ? [{ key: '7-3', label: <Link to="/difundir-resumen-cuenta">Resumen de cuenta</Link> }]
          : []),
        ...(enableNoticia && permisos.difundirNoticia !== false
          ? [{ key: '7-4', label: <Link to="/difundir-noticia">Noticia</Link> }]
          : [])
      ],
    },
    {
      key: '10',
      icon: <LogoutOutlined style={{ color: 'red' }} />,
      label: (
        <span style={{ color: 'red' }} onClick={() => logout()}>
          Cerrar sesión
        </span>
      ),
    }
  ].filter((item) => {
    if (item.key !== '7') return true;
    return Array.isArray(item.children) && item.children.length > 0;
  });

  const coopManagerMenuItems = [
    ...clientMenuItems.slice(0, -1),
    { key: '9', icon: <TeamOutlined />, label: <Link to="/usuarios">Usuarios</Link> },
    clientMenuItems[clientMenuItems.length - 1],
  ];

  // Seleccionar el menú según el tipo de usuario
  const menuItems =
    user?.user?.tipoUsuario === 'administrador' && !user?.user?.idCooperativa
      ? adminMenuItems
      : canManageUsers
        ? coopManagerMenuItems
        : clientMenuItems;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null} // Oculta el trigger por defecto
        style={{
          background: '#000000', // Fondo negro
          color: '#666666', // Color del texto
          position: 'relative',
        }}
      >
        <div className="demo-logo-vertical" />
        <Menu
          theme="dark"
          defaultSelectedKeys={['1']}
          mode="inline"
          items={menuItems}
          style={{
            background: '#000000', // Fondo negro
            color: '#666666', // Color del texto
          }}
        />
        {/* Trigger personalizado */}
        <div
          onClick={() => setCollapsed(!collapsed)}
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            background: '#000000',
            textAlign: 'center',
            padding: '10px 0',
            cursor: 'pointer',
            color: '#666666', // Cambia el color de la flecha aquí
            fontSize: '18px',
          }}
        >
          {collapsed ? <RightOutlined /> : <LeftOutlined />}
        </div>
      </Sider>
      <Layout>
        <Content
          style={{
            margin: '0px',
          }}
        >
          <div
            style={{
              padding: 12
            }}
          >
            {children}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
